import axios from 'axios';

export const apiURL = (() => {
  switch (process.env.REACT_APP_ENV) {
    case 'development':
      return process.env.REACT_APP_HTTPS
        ? 'https://local.desktop.enki.com:1234'
        : 'http://localhost:1234';
    case 'staging':
      return 'https://staging.desktop.enki.com';
    case 'production':
      return 'https://desktop.enki.com';
    default:
      return 'http://localhost:1234';
  }
})();

export const apiClientId = 'ENKI';

axios.defaults.baseURL = apiURL;
axios.defaults.headers.common['x-client-id'] = apiClientId;
